// extracted by mini-css-extract-plugin
module.exports = {"Emojis__item":"ye_a zu_tg zu_pq zu_uh"};